import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export default function FAQ() {
  const { t } = useLanguage();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-28 px-6 md:px-12"
      style={{ background: '#ffffff' }}
    >
      <div className="max-w-3xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-heading text-4xl sm:text-5xl md:text-6xl text-[#050505] font-bold tracking-tighter mb-14"
            data-testid="faq-label"
          >
            {t.faq.label}
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <Accordion type="single" collapsible className="w-full">
              {t.faq.items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-black/10"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="font-heading text-base md:text-lg text-[#050505] font-bold tracking-tight hover:text-[#e14141] hover:no-underline py-6 [&[data-state=open]]:text-[#e14141]"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-answer-${i}`}
                    className="font-body text-sm md:text-base text-zinc-600 pb-6 leading-relaxed"
                  >
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
    </section>
  );
}
